/**
 * Shared language state.
 *
 * Uses ``sessionStorage`` so the customer's language stays consistent as
 * they navigate landing → verify → dashboard, but is not persisted across
 * a full browser close (matching the Phase-1 behavior).
 */
import { useCallback, useEffect, useState } from 'react';
import { CONTENT } from '@/i18n/content';

const KEY = 'zmex_lang_v1';

export function useLang() {
  const [lang, setLangState] = useState(() => {
    try {
      const saved = sessionStorage.getItem(KEY);
      return saved === 'es' ? 'es' : 'en';
    } catch {
      return 'en';
    }
  });

  useEffect(() => {
    document.documentElement.lang = lang;
    try {
      sessionStorage.setItem(KEY, lang);
    } catch {
      /* ignore */
    }
  }, [lang]);

  const toggle = useCallback(() => {
    setLangState((l) => (l === 'en' ? 'es' : 'en'));
  }, []);

  return { lang, t: CONTENT[lang], toggle };
}
